import { renderRichText } from '../../../core/utils/render-rich-text.util';

export function adaptTableBlock(
  entry: Record<string, unknown>,
  _baseUrl: string,
): Record<string, unknown> {
  const footnotes = Array.isArray(entry['footnotes'])
    ? entry['footnotes'].map((f: unknown) => renderRichText(String(f ?? '')))
    : [];

  return {
    data: {
      headers: Array.isArray(entry['headers']) ? entry['headers'] : [],
      rows: Array.isArray(entry['rows']) ? entry['rows'] : [],
      footnotes,
    },
    compact: entry['compact'] === true,
  };
}
